// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"03119072","977":"ce821ba1"}[chunkId] + ".chunk.js";
};